import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementLocale from "element-ui/lib/locale";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // elementui 的中文语言包
import elementEnLocale from "element-ui/lib/locale/lang/en"; // elementui 的英文语言包
import langZh from "./language/zh.js";
import langEN from "./language/en.js";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh',
  messages: {
    zh: { ...langZh, ...elementZhLocale },
    en: { ...langEN, ...elementEnLocale }
  }
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
